import {Component, Input, OnInit} from '@angular/core';
import {Competitor, Country, Lookups} from "@model";
import {NgbActiveModal, NgbDateParserFormatter} from "@ng-bootstrap/ng-bootstrap";
import {FormControl, FormGroup} from "@angular/forms";
import {
  alphabetical,
  email,
  max_length_100,
  max_length_45,
} from "@utility";
@Component({
  selector: 'my-entry-personal-info-modal',
  templateUrl: './my-entry-personal-info-modal.component.html',
  styleUrl: './my-entry-personal-info-modal.component.scss',
  standalone: false
})
export class MyEntryPersonalInfoModalComponent implements OnInit {
  @Input() competitor: Competitor | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Country[] = [];
  @Input() genders: Lookups[] = [];

  currentDate: Date = new Date();

  editStates: { [key: string]: boolean } = {};
  inputForm = new FormGroup({
    firstname: new FormControl(),
    lastname: new FormControl(),
    email: new FormControl(),
    gender: new FormControl(),
    birthDay: new FormControl(),
    club: new FormControl(),
  });

  constructor(public activeModal: NgbActiveModal,
              public formatter: NgbDateParserFormatter) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.inputForm.controls.firstname.addValidators([max_length_45, alphabetical]);
    this.inputForm.controls.lastname.addValidators([max_length_45, alphabetical]);
    this.inputForm.controls.email.addValidators([email]);
    this.inputForm.controls.club.addValidators([max_length_100]);
  }

  get activeEditCount(): number {
    return Object.values(this.editStates).filter(state => state).length;
  }

  onEdit(fieldName: string): void {
    this.editStates[fieldName] = !this.editStates[fieldName];
  }

  //TODO
  onSubmitCorrection(): void {

  }
}
